import * as React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { Checkbox, Box } from '@mui/material'; 

import EditIcon from '@mui/icons-material/Edit';



function createData(name, code, population, size) {
  const density = population / size;
  return { name, code, population, size, density };
}

const rows = [
{
    id:1,
    category_name:'Primary',
    description:'',
    status:true
},
{
    id:2,
    category_name:'Primary',
    description:'',
    status:false
},
{
    id:3,
    category_name:'Primary',
    description:'blaah blaah blaah',
    status:true
},
{
    id:4,
    category_name:'Primary',
    description:'testing testing',
    status:false
},
{
    id:5,
    category_name:'Primary',
    description:'',
    status:true
},
{
    id:6,
    category_name:'Primary',
    description:'',
    status:true
},
{
    id:7,
    category_name:'Primary',
    description:'testing testing',
    status:false
},
{
    id:8,
    category_name:'Primary',
    description:'',
    status:true
},
{
    id:9,
    category_name:'Primary',
    description:'',
    status:true
},
{
    id:10,
    category_name:'Primary',
    description:'testing testing',
    status:false
},
{
    id:11,
    category_name:'Primary',
    description:'',
    status:true
},
{
    id:12,
    category_name:'Primary',
    description:'',
    status:true
},
];

export default function CustomerReportTable({title}) {
  const [page, setPage] = React.useState(0);
  const rowsPerPageOptions = [20, 50, 100, 200];
  const [rowsPerPage, setRowsPerPage] = React.useState(rowsPerPageOptions[1]);


  const columns = [
    { id: 'customer name', label: 'Customer Name', minWidth: 170 },
    { id: 'no of invoice', label: ` No Of Invoice`, minWidth: 100 },
    {
      id: 'total due',
      label: 'total due',
      minWidth: 170,
      align: 'right',
      format: (value) => value.toLocaleString('en-US'),
    },
    {
      id: 'last invoice',
      label: 'Last Invoice',
      minWidth: 170,
      align: 'right',
      format: (value) => value.toLocaleString('en-US'),
    },
   
  ];


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <Paper sx={{ width: '100%' }}>
      <TableContainer sx={{ maxHeight: 440 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                //   align={column.align}
                //   style={{ top: 0, minWidth: column.minWidth }}
                >
                  <b>{column.label}</b>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => {
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                        <TableCell >{row.id}</TableCell>
                        <TableCell >{row.category_name}</TableCell>
                        <TableCell >{row.category_name}</TableCell>
                        <TableCell >{row.category_name}</TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={rowsPerPageOptions}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
}